// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1f","title":"e_2f","wavy":"e_3f","navLink":"e_4f","active":"e_5f","iconArrow":"e_6f"};